import {TimeZoneStore} from '@/constants/actionType';

export function setIsAutoSync(value) {
  return {
    type: TimeZoneStore.SET_IS_AUTO_SYNC,
    value,
  };
}

export function setGeoArea(value) {
  return {
    type: TimeZoneStore.SET_GEO_AREA,
    value,
  };
}

export function setRegion(value) {
  return {
    type: TimeZoneStore.SET_REGION,
    value,
  };
}

export function setDate(value) {
  return {
    type: TimeZoneStore.SET_DATE,
    value,
  };
}

export function setTime(value) {
  return {
    type: TimeZoneStore.SET_TIME,
    value,
  };
}

export function setOrigin(value) {
  return {
    type: TimeZoneStore.SET_ORIGIN,
    value,
  };
}

export function setInit({isAutoSync, geoArea, region, date, time, origin}) {
  return {
    type: TimeZoneStore.SET_INIT,
    isAutoSync,
    geoArea,
    region,
    date,
    time,
    origin,
  };
}

export function updateTimeZone({isAutoSync, geoArea, region, date, time}) {
  return {
    type: TimeZoneStore.SET_TIMEZONE,
    isAutoSync,
    geoArea,
    region,
    date,
    time,
  };
}

export function reset() {
  return {
    type: TimeZoneStore.RESET,
  };
}
